import React, { useCallback, useState } from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useBlocks, useUi } from "@jelly/lesson";
import { useIntl } from "react-intl";

import { messages } from "./Introduction.messages";
import styles from "./Introduction.module.scss";

import { NielsBioModal } from "./components/NielsBioModal";

interface Introduction {
  title: string;
}

export const Introduction: React.FC<Introduction> = ({ title }) => {
  const ui = useUi();
  const blocks = useBlocks();
  const { formatMessage } = useIntl();
  const [nielsModalOpen, setNielsModalOpen] = useState(false);

  const handleNielsModalToggle = useCallback(() => setNielsModalOpen((open) => !open), []);

  const leftComponent = (
    <div className={styles.accordion}>
      <p>{formatMessage(messages.description)}</p>
      <ui.Button shape={"normal"} theme={"primary"} size={"small"} onClick={handleNielsModalToggle}>
        {formatMessage(messages.bioNote)}
      </ui.Button>
    </div>
  );

  return (
    <StandardCase title={title} leftComponent={leftComponent}>
      <div className={styles.gallery}>
        <blocks.video src={"https://youtu.be/HkCRqc0R3Qk"} provider={"youtube"} />
      </div>
      <NielsBioModal visible={nielsModalOpen} onClose={handleNielsModalToggle} />
    </StandardCase>
  );
};
